<template>
    <div id="home" >
        <header-bar></header-bar>
        <div id="home-content">
          <menu-tree></menu-tree>
          <page-table></page-table>
        </div>
    </div>
</template>
<script>
import store from '@/store'
import MenuTree from '@/components/MenuTree'
import PageTable from '@/components/PageTable'
import HeaderBar from '@/components/HeaderBar'


export default {
  name: 'Home',
  components: {
    MenuTree,
    PageTable,
    HeaderBar
  }
  
}
</script>
<style scoped lang="scss">
  #home{
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  #home-content {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }
  
</style>


// WEBPACK FOOTER //
// src/Home.vue